// extracted by mini-css-extract-plugin
export default {"Main":"YAz35","Main_hidden":"FO4Cd","Main_displayed":"RTSI4","mainPrecontentWrapper":"Phk2T","mainCategoryNameWrapper":"dd3kf","mainCategoryName":"lnIe9"};